import r from "./restArguments.js";
import e from "./_executeBound.js";
import t from "./underscore.js";
var o = r(function (r, t) {
  var n = o.placeholder,
    a = function a() {
      for (var o = 0, s = t.length, u = Array(s), f = 0; f < s; f++) u[f] = t[f] === n ? arguments[o++] : t[f];
      for (; o < arguments.length;) u.push(arguments[o++]);
      return e(r, a, this, this, u);
    };
  return a;
});
o.placeholder = t;
export { o as default };